var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9643 0C49.5225 0 50.7857 1.26853 50.7857 2.83333C50.7857 4.28637 49.6965 5.48394 48.2933 5.6476L47.9643 5.66667L5.64286 5.66667L5.64286 11.3333L73.3571 11.3333L73.3571 5.66667L70.5357 5.66667C69.0888 5.66667 67.8962 4.57289 67.7333 3.16376L67.7143 2.83333C67.7143 1.3803 68.8035 0.18273 70.2067 0.0190619L70.5357 0L76.1786 0C77.6255 0 78.818 1.09378 78.981 2.50291L79 2.83333L79 14.1667C79 15.6197 77.9108 16.8173 76.5076 16.9809L76.1786 17L2.82143 17C1.3745 17 0.181962 15.9062 0.0189818 14.4971L0 14.1667L0 2.83333C0 1.3803 1.08918 0.18273 2.49239 0.0190619L2.82143 0L47.9643 0Z",
    transform: "translate(5 11)",
    id: "Path",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(62 11)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1786 0L2.82143 0C1.2632 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.2632 17 2.82143 17L76.1786 17C77.7368 17 79 15.7315 79 14.1667L79 2.83333C79 1.26853 77.7368 0 76.1786 0ZM73.3571 5.66667L73.3571 11.3333L5.64286 11.3333L5.64286 5.66667L73.3571 5.66667Z",
    transform: "translate(5 62)",
    id: "Path-18-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 0L5.66667 36.4L62.3333 36.4L62.3333 0L68 0L68 42L0 42L0 0L5.66667 0Z",
    transform: "translate(11 25)",
    id: "Path-19",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.435 0.636285C39.8639 -0.0201749 40.7331 -0.197563 41.3764 0.240076C41.9483 0.629089 42.1492 1.37311 41.8855 1.99469L41.7647 2.22112L30.5648 19.3637C30.1835 19.9472 29.4544 20.1522 28.8452 19.8832L28.6233 19.7599L12.7764 8.98002L2.38994 19.5814C1.90396 20.0773 1.14957 20.1324 0.603942 19.7467L0.410049 19.5814C-0.075935 19.0855 -0.129933 18.3158 0.248054 17.759L0.410049 17.5612L11.61 6.13276C12.0229 5.71144 12.6406 5.60158 13.1606 5.83375L13.3765 5.95428L29.0107 16.5856L39.435 0.636285Z",
    transform: "translate(24 35)",
    id: "Path-20",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0ZM4 2.66667C4.73638 2.66667 5.33333 3.26362 5.33333 4C5.33333 4.73638 4.73638 5.33333 4 5.33333C3.26362 5.33333 2.66667 4.73638 2.66667 4C2.66667 3.26362 3.26362 2.66667 4 2.66667Z",
    transform: "translate(21 49)",
    id: "Oval",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0ZM4 2.66667C4.73638 2.66667 5.33333 3.26362 5.33333 4C5.33333 4.73638 4.73638 5.33333 4 5.33333C3.26362 5.33333 2.66667 4.73638 2.66667 4C2.66667 3.26362 3.26362 2.66667 4 2.66667Z",
    transform: "translate(33 38)",
    id: "Oval",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0ZM4 2.66667C4.73638 2.66667 5.33333 3.26362 5.33333 4C5.33333 4.73638 4.73638 5.33333 4 5.33333C3.26362 5.33333 2.66667 4.73638 2.66667 4C2.66667 3.26362 3.26362 2.66667 4 2.66667Z",
    transform: "translate(49 49)",
    id: "Oval",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0ZM4 2.66667C4.73638 2.66667 5.33333 3.26362 5.33333 4C5.33333 4.73638 4.73638 5.33333 4 5.33333C3.26362 5.33333 2.66667 4.73638 2.66667 4C2.66667 3.26362 3.26362 2.66667 4 2.66667Z",
    transform: "translate(61 33)",
    id: "Oval-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 0C4.25485 0 5.44361 1.08574 5.60608 2.4845L5.625 2.8125L5.625 8.4375C5.625 9.9908 4.3658 11.25 2.8125 11.25C1.37015 11.25 0.181386 10.1643 0.0189217 8.7655L0 8.4375L0 2.8125C0 1.2592 1.2592 0 2.8125 0Z",
    transform: "matrix(0.70710677 -0.70710677 0.70710677 0.70710677 44.658783 76.76126)",
    id: "Path-21-Copy-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 0C4.25485 0 5.44361 1.08574 5.60608 2.4845L5.625 2.8125L5.625 8.4375C5.625 9.9908 4.3658 11.25 2.8125 11.25C1.37015 11.25 0.181386 10.1643 0.0189217 8.7655L0 8.4375L0 2.8125C0 1.2592 1.2592 0 2.8125 0Z",
    transform: "matrix(-0.7071067 -0.7071068 -0.7071068 0.7071067 45.341217 76.76126)",
    id: "Path-21-Copy-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/engagement.9b728fbb23913f33dd0c9a7ac5753695.svg";
export { ForwardRef as ReactComponent };